

import qs from "qs";
import * as axiosHelper from "./api_helper";
import { readReportResult } from "./reportResponse";

const withTimezoneOffset = (params = {}) => ({
  ...params,
  tzOffset: params?.tzOffset ?? -new Date().getTimezoneOffset(),
});

export const getReports = async ({ payload }) => {
  const { reportType, ...params } = payload;
  const data = await axiosHelper.get(`/reports/${reportType}?${qs.stringify(withTimezoneOffset(params))}`);
  return readReportResult(data);
};

export const downloadReport = async (payload) => {
  const { reportType, ...params } = payload;
  const response = await axiosHelper.get(`/reports/download/${reportType}?${qs.stringify(withTimezoneOffset(params))}`, { responseType: "blob" });
  if (!(response instanceof Blob)) throw new Error(response?.message || "Could not download report");
  return response;
};

export const getAffiliateReports = async ({ payload, clientId }) => {
  const data = await axiosHelper.get(`/affiliate/${clientId}?${qs.stringify(payload)}`);
  return data.result;
};

export const getSymbols = async (params = {}) => {
  const query = qs.stringify(params || {});
  const url = query ? `/reports/symbols?${query}` : "/reports/symbols";
  const data = await axiosHelper.get(url);
  return data.result;
};
